import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/layouts/default.vue").then(m => m.default || m))
}